import axios from 'axios';
import {actions as A} from '../../constants/actions';
import {api} from '../../constants/api';
import {errors as E} from 'common/constants/errors';

export const updateCalcWeights = ({data}) => {
  return (dispatch) => {
    dispatch({
      type: A.GET_STEP_DATA
    });

    return axios.post(api.STEP_10_UPDATE_CALC_WEIGHTS, data)
      .then((response) => {
        const {errorCode, body} = response.data;
        if (errorCode < 0) throw new Error(E.SERVER_ERROR);

        dispatch({
          type: A.GET_STEP_DATA_SUCCESS,
          payload: body
        });
      })
  };
};
